export const isUserReader = user => user.glpiactiveprofile === "Leitura";
